import React, {useEffect} from 'react';
import {Grid, Typography, Box, Table, TableRow, TableCell} from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment-timezone";
import {HHMMFromMilliseconds} from "../../../utils/date";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    text: {
        opacity: '0.7',
        fontFamily: 'Manrope',
        letterSpacing: '0.11px',
        marginBottom: '20px'
    },
    sessionDetailWrapper:{
        backgroundColor: '#191919',
        padding: '24px 22px',
        [theme.breakpoints.down('xs')]: {
            padding: '20px 12px',
        },
    },
    heading: {
        fontSize: '20px',
        lineHeight: '30.9px',
        padding: '0 0 16px',
        letterSpacing: '0.11px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '16px',
            lineHeight: '24.72px',
        },
    },
    tableHead: {
        borderBottom: '0',
        padding: '0 0 19px',
        fontFamily: 'Manrope',
        fontSize: '16px',
        lineHeight: '24px',
        letterSpacing: '0.11px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '14px',
            padding: '0 0 15px',
        },
    },
    tableCell: {
        borderBottom: '0',
        padding: '0 0 19px',
        fontFamily: 'Manrope',
        fontSize: '16px',
        lineHeight: '24px',
        opacity: '0.7',
        color: '#fff',
        letterSpacing: '0.11px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '14px',
            padding: '0 0 15px',
        },
    }
}));

export default function SessionDetail({sessionData}){
    const classes = useStyles();

    useEffect(()=>{
        document.getElementById('sessionDesc').innerHTML = sessionData.description;
    }, [sessionData])
    return(
        <>
            <Grid container>
                <Grid md={7} xs={12}>
                    <Typography id={'sessionDesc'} component="p" className={classes.text}>

                    </Typography>
                </Grid>
                <Grid md={1} xs={12}></Grid>
                <Grid md={4} xs={12}>
                    <Box component="div" m={1} style={{border: '1px solid rgba(255, 255, 255, 0.06)',
                boxShadow: '0px 16px 32px -4px rgba(0, 0, 0, 0.12)'}}  className={classes.sessionDetailWrapper}>
                        <Typography component="h3" className={classes.heading}>
                        Session Details
                        </Typography>
                        <Table>
                            <TableRow>
                                <TableCell variant="head" className={classes.tableHead}>Date</TableCell>
                                <TableCell className={classes.tableCell}>{moment(sessionData.startDate).format("dddd MMM D, YYYY")}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="head" className={classes.tableHead}>Time</TableCell>
                                <TableCell className={classes.tableCell}>{moment(sessionData.startDate).format('h:mma')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="head" className={classes.tableHead}>Duration</TableCell>
                                <TableCell className={classes.tableCell}>{HHMMFromMilliseconds(new Date(sessionData.endDate) - new Date(sessionData.startDate))}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell variant="head" className={classes.tableHead} style={{padding: '0'}}>Language</TableCell>
                                <TableCell className={classes.tableCell} style={{padding: '0'}}>{sessionData.language || 'English'}</TableCell>
                            </TableRow>
                        </Table>

                    </Box>
                </Grid>
            </Grid>
        </>
    )
}